import { render } from "./BlockMenuBar.vue?vue&type=template&id=407ffa8e"
import script from "./BlockMenuBar.vue?vue&type=script&lang=js"
export * from "./BlockMenuBar.vue?vue&type=script&lang=js"

import "./BlockMenuBar.vue?vue&type=style&index=0&id=407ffa8e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__